import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useContext, useEffect, useState } from "react";
import { SUBSCRIPTION_ERROR_EVENT, SUBSCRIPTION_SUCCESS_EVENT } from "../constants";
import PusherContext from "../PusherContext";
function usePusherChannel(_ref) {
  var channelName = _ref.channelName,
    _ref$events = _ref.events,
    events = _ref$events === void 0 ? [] : _ref$events;
  var context = useContext(PusherContext);
  if (context === undefined) {
    throw new Error('usePusherChannel must be used within a PusherContext provider.');
  }
  var connected = context.connected,
    pusher = context.pusher;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    subscriptionSucceeded = _useState2[0],
    setSubscriptionSucceeded = _useState2[1];
  useEffect(function () {
    try {
      if (pusher && connected && channelName) {
        var channel = pusher.subscribe(channelName);
        channel.bind(SUBSCRIPTION_SUCCESS_EVENT, function () {
          setSubscriptionSucceeded(true);
        });
        channel.bind(SUBSCRIPTION_ERROR_EVENT, function (status) {});
        events.forEach(function (event) {
          channel.bind(event.eventName, event.handler);
        });
      }
    } catch (error) {
      console.error(error);
    }
    return function () {
      if (pusher && channelName) {
        pusher.unsubscribe(channelName);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pusher, connected, channelName]);
  return {
    connected: connected,
    subscriptionSucceeded: subscriptionSucceeded
  };
}
export default usePusherChannel;